export enum NodeStatus {
  GHOST = "ghost",          // 👻 Blueprint only
  PENDING = "pending",      // ⏳ Queued for generation
  HYDRATING = "hydrating",  // 🌀 Agent is working
  FRESH = "fresh",          // 🟢 Content exists & synced
  STALE = "stale",          // 🟡 Upstream dependency changed
  LOCKED = "locked"         // 🔒 User override
}

export interface ArtifactoryNode {
  id: string;
  name: string;
  path: string;
  type: "file" | "directory";
  status: NodeStatus;

  // Intelligence
  assigned_persona_id: string;
  generation_prompt: string;

  // Topology
  dependencies: string[]; // IDs of other nodes
  dependents?: string[];  // IDs of nodes that depend on this

  // Materialization
  artifact_id?: string;   // Link to actual content
  last_hydrated?: string;

  // Metadata (hydration_count, last_hydration, etc.)
  metadata?: Record<string, unknown>;
}

export interface ProjectManifest {
  id: string; // The Artifact ID containing this manifest
  root_context: string;
  nodes: Record<string, ArtifactoryNode>;
  version: number;
  metadata?: Record<string, unknown>;
}

export interface HandoffPlugin {
  name: string;
  display_name: string;
  icon: string;
  description: string;
  instruction_filename: string;
  has_config_dir: boolean;
  has_skills: boolean;
}

export interface HandoffOptions {
  includeStale?: boolean;
  includeGhost?: boolean;
  includeBuildOrder?: boolean;
  includeIntentHistory?: boolean;
}
